import { render, staticRenderFns } from "./create-asset-wizard.vue?vue&type=template&id=976526a6&scoped=true&"
import script from "./create-asset-wizard.vue?vue&type=script&lang=ts&"
export * from "./create-asset-wizard.vue?vue&type=script&lang=ts&"
import style0 from "./create-asset-wizard.vue?vue&type=style&index=0&id=976526a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976526a6",
  null
  
)

export default component.exports